import packageJson from '../../../package.json' with { type: 'json' }

export const SEO_VERSION = packageJson.version
